import React from 'react'

interface Props {
  children: React.ReactNode
  /** 捕获后通知宿主（浮窗据此把窗口状态收回 closed，否则入口按钮点了没反应） */
  onError?: () => void
}
interface State { hasError: boolean }

/** 极简错误边界:聊天组件任何渲染错误都被吞掉(渲染 null),绝不波及外层业务布局。 */
export class AIChatErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }
  static getDerivedStateFromError(): State { return { hasError: true } }
  componentDidCatch(error: unknown) {
    console.error('[ai-chat] widget crashed (isolated):', error)
    this.props.onError?.()
  }
  render() { return this.state.hasError ? null : this.props.children }
}
